<div class="modal-body modal-style">
  <div>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div>
    <div class="pagination-container" *ngIf="bookings.length > 1">
      <button
        class="icon-btn"
        (click)="previous()"
        [disabled]="currentIndex === 0"
        aria-label="Previous"
      >
        «
      </button>
      <span class="page-indicator">
        {{ currentIndex + 1 }} / {{ bookings.length }}
      </span>
      <button
        class="icon-btn"
        (click)="next()"
        [disabled]="currentIndex === bookings.length - 1"
        aria-label="Next"
      >
        »
      </button>
    </div>
    <div class="row">
      <div class="col-12 title">
        <h5 class="heading-5">
          <div class="icon-bcg">
            <img src="assets/img/svg/clipboard.svg" />
          </div>
          {{ "company.company-booked.booked-details" | translate }}
        </h5>
      </div>
    </div>
    <div *ngIf="activeBooking">
      <div>
        <!-- DETALLES DE LA RESERVA -->
        <div *ngIf="loading" style="display: block; margin: auto">
          <app-loading [userType]="'employee'"></app-loading>
        </div>
        <!--AUTOMATIZED HOTEL-->
        <ng-container
          *ngIf="type === 'flight' || type === 'train' || type === 'car'"
        >
          <div class="title-content-container">
            <div class="title">
              <div>
                {{ "my-bookeds.train-flight.origin" | translate }}
              </div>
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.origin?.name ? activeBooking.origin.name : activeBooking.from }}</span>
              <a
                class="external-link"
                [href]="createGMapsLink(activeBooking?.origin?.name ? activeBooking.origin.name : activeBooking.from)"
                target="_blank"
                [title]="'common.external-link' | translate"
                ><img
                  src="assets/img/svg/open-external-link-icon.svg"
                  alt=""
                  width="10px"
              /></a>
            </div>
          </div>
          <div class="title-content-container">
            <div class="title">
              <div>
                {{ "my-bookeds.train-flight.destiny" | translate }}
              </div>
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.destination?.name ? activeBooking.destination?.name : activeBooking.to }}</span>
              <a
                class="external-link"
                [href]="createGMapsLink(activeBooking.destination?.name ? activeBooking.destination?.name : activeBooking.to)"
                target="_blank"
                [title]="'common.external-link' | translate"
                ><img
                  src="assets/img/svg/open-external-link-icon.svg"
                  alt=""
                  width="10px"
              /></a>
            </div>
          </div>
        </ng-container>
        <!--CAR-->
        <ng-container *ngIf="type === 'car'">
          <div class="title-content-container">
            <div class="title">
              {{ "car.vehicle-type" | translate }}
            </div>
            <div class="content">
              <div class="form-group mr-2">
                <span class="labels">{{
                  ( activeBooking.carType === "suv"?
                  "car.custom.request.carType.suv"
                    : activeBooking.carType === "touring"?
                    "car.custom.request.carType.touring"
                    : "car.custom.request.carType.van"
                  ) | translate
                }}</span>
              </div>
            </div>
          </div>
          <div class="title-content-container">
            <div class="title">
              {{ "car.custom.request.pickup.titleFrom" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{
                (activeBooking.pickupPlaceFrom === "airport"
                  ? "car.custom.request.pickup.airport"
                  : activeBooking.pickupPlaceFrom === "trainStation"
                  ? "car.custom.request.pickup.trainStation"
                  : "car.custom.request.pickup.office"
                ) | translate
              }}</span>
            </div>
          </div>
          <div class="title-content-container">
            <div class="title">
              {{ "car.custom.request.pickup.titleTo" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{
                (activeBooking.pickupPlaceTo === "airport"
                  ? "car.custom.request.pickup.airport"
                  : activeBooking.pickupPlaceFrom === "trainStation"
                  ? "car.custom.request.pickup.trainStation"
                  : "car.custom.request.pickup.office"
                ) | translate
              }}</span>
            </div>
          </div>
        </ng-container>
        <div class="title-content-container">
          <div class="title">
            {{ "car.custom.request.total" | translate }}
          </div>
          <div class="content">
            <span class="labels" *ngIf="type !== 'train'">
              {{
                type === 'flight'
                  ? ((activeBooking.price?.individualPrice ?? activeBooking.price ?? activeBooking.amount) | price)
                  : ((activeBooking.price ?? activeBooking.amount) | price)
              }}
            </span>
            <span class="labels" *ngIf="type === 'train'">
              {{ getTrainDisplayPrice(activeBooking) | price }}
            </span>
          </div>
        </div>
        <div class="title-content-container"*ngIf="activeBooking.apiPrice?.totalPrice">
          <div class="title">
            {{ "car.custom.request.total" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{ activeBooking?.price || activeBooking?.apiPrice?.totalPrice?.total }}</span>
            
          </div>
        </div>
        <div
          class="title-content-container"
          *ngIf="(activeBooking.baseRate ?? activeBooking.apiPrice?.baseRate?.amount) !== null && (activeBooking.baseRate ?? activeBooking.apiPrice?.baseRate?.amount) !== undefined"
        >
          <div class="title">
            {{ "hotel.base-rate" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{
                (
                  activeBooking.baseRate ??
                  activeBooking.apiPrice?.baseRate?.amount
                ) | price
              }}
            </span>
          </div>
        </div>

        <div
          class="title-content-container"
          *ngIf="(activeBooking.taxAndServiceFee ?? activeBooking.apiPrice?.taxAndServiceFee?.amount) > 0"
        >
          <div class="title">
            {{ "hotel.taxes-and-fees" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{
                (
                  activeBooking.taxAndServiceFee ??
                  activeBooking.apiPrice?.taxAndServiceFee?.amount
                ) | price
              }}
            </span>
          </div>
        </div>

        <div
          class="title-content-container"
          *ngIf="(activeBooking.salesTax ?? activeBooking.apiPrice?.salesTax?.amount) > 0"
        >
          <div class="title">
            {{ "hotel.sales-tax" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{
                (
                  activeBooking.salesTax ??
                  activeBooking.apiPrice?.salesTax?.amount
                ) | price
              }}
            </span>
          </div>
        </div>

        <div
          class="title-content-container"
          *ngIf="(activeBooking.fees ?? activeBooking.apiPrice?.fees?.amount) > 0"
        >
          <div class="title">
            {{ "flights.form.fees" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{
                (
                  activeBooking.fees ??
                  activeBooking.apiPrice?.fees?.amount
                ) | price
              }}
            </span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.wholesalePrice && isEmployee">
          <div class="title">
            {{ "company.company-booked.wholesale-price-euro" | translate }}
          </div>
          <div class="content">
           <span class="labels">
            {{ getWholesaleDisplayPrice(activeBooking) | price }}
          </span>
          </div>
        </div>
        <!-- EXPENSE -->
        <div class="title-content-container" *ngIf="type === 'expense'">
          <div class="title">
            {{ "authorization.labels.from" | translate }}
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.beginDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY"}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense'">
          <div class="title">
            {{ "authorization.labels.to" | translate }}
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.endDate | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY"}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.provider">
          <div class="title">
            {{ 'my-bookeds.view.provider' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.provider | titlecase }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.order">
          <div class="title">
            {{"company.booked.order-code" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.order}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.supplierInvoice">
          <div class="title">
            {{ 'company.bills.supplier-invoice' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.supplierInvoice }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.invoiced">
          <div class="title">
            {{ 'flight.multifamily.baggage' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ ('company.company-booked.invoiced-' + activeBooking.invoiced) | translate }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.bookType">
          <div class="title">
            {{ 'company.company-booked.booking-type' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ (getBookTypeKey(activeBooking.bookType) | translate) || activeBooking.bookType }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.paymentCard && fromTransactions && (type === 'expense')">
          <div class="title">{{"company.transaction.filters.payment-card" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.paymentCard.name}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.locator">
          <div class="title">{{"my-bookeds.train-flight.locator" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.locator}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.costCenter">
          <div class="title">
            {{"common.cost-center" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.costCenter}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.customCode">
          <div class="title">
            {{"common.custom-code" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.customCode}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.annotationsExtras">
          <div class="title">
            {{"expenses.extra-annotations" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.annotationsExtras }}</span>
          </div>
        </div>

        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.comments">
          <div class="title">
            {{"expenses.comments" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.comments }}</span>
          </div>
        </div>

        <div class="title-content-container" *ngIf="type === 'expense' && isEmployee && activeBooking.adminComments">
          <div class="title">
            {{"expenses.admin-comments" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.adminComments }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense'">
          <div class="title">
            {{ "my-bookeds.train-flight.status" | translate }}
          </div>
          <div
            class="content"
            [ngClass]="{
              danger: activeBooking?.status && activeBooking?.status?.toLowerCase() === 'cancelled',
              success: !activeBooking?.status || (activeBooking?.status && activeBooking?.status?.toLowerCase() === 'active' || activeBooking?.status?.toLowerCase() === 'confirmed'),
              info: activeBooking?.status && activeBooking?.status?.toLowerCase() === 'pending'
            }"
          >
            <span class="labels">{{
              (!activeBooking?.status || (activeBooking?.status && activeBooking?.status?.toLowerCase() === 'active' || activeBooking?.status?.toLowerCase() === 'confirmed')
                ? "common.confirmed"
                : "common." + activeBooking?.status?.toLowerCase()
              ) | translate
            }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense'">
          <div class="title">
            Tipo
          </div>
          <div class="content">
            <span class="labels">{{activeBooking.type}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.travelTitle">
          <div class="title">{{"excel.related-project" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.travelTitle}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense'">
          <div class="title">
            {{'my-bookeds.flight.travellers' | translate}}
          </div>
          <div class="content">
            <span class="labels">{{ getTravellerDisplayName(activeBooking, booking) }}</span>
            </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'expense' && activeBooking.agent && isEmployee">
            <div class="title">
              <span>{{ "project.my-projects.agent" | translate }}</span>
            </div>
            <div class="content">
              <span>{{activeBooking.agent | titlecase}}</span>
            </div>
          </div>
        <div class="title-content-container" *ngIf="isEmployee && activeBooking.marketingFee && (type === 'bookingApiReference' || type === 'custom-booking')">
          <div class="title">{{"my-bookeds.view.marketing-fee" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.marketingFee}}</span>
          </div>
        </div>
        <!--HOTEL FLIGHT TRAIN-->
        <div
          class="title-content-container"
          *ngIf="type !== 'car' && type !== 'expense'"
        >
          <div class="title">
            {{ "my-bookeds.train-flight.status" | translate }}
          </div>
          <div
            class="content"
            [ngClass]="{
              danger: activeBooking?.status && activeBooking?.status?.toLowerCase() === 'cancelled',
              success: !activeBooking?.status || (activeBooking?.status && activeBooking?.status?.toLowerCase() === 'active' || activeBooking?.status?.toLowerCase() === 'confirmed'),
              info: activeBooking?.status && activeBooking?.status?.toLowerCase() === 'pending'
            }"
          >
            <span class="labels">{{
              (!activeBooking?.status || (activeBooking?.status && activeBooking?.status?.toLowerCase() === 'active' || activeBooking?.status?.toLowerCase() === 'confirmed')
                  ? 'common.confirmed'
                  : 'common.' + activeBooking?.status?.toLowerCase()
              ) | translate
          }}</span>
          </div>
        </div>
        <div
          *ngIf="type === 'flight' || type === 'train'"
          class="title-content-container"
        >
          <div class="title">
            {{ "my-bookeds.train-flight.type-travel" | translate }}
          </div>
          <div class="content">
            <span class="labels">{{
              (activeBooking.oneWay
                ? "my-bookeds.train-flight.oneWay"
                : "my-bookeds.train-flight.notOneWay"
              ) | translate
            }}</span>
          </div>
        </div>
        <!--HOTEL FLIGHT TRAIN CAR-->
        <ng-container *ngIf="type !== 'expense'">
          <div class="title-content-container">
            <div class="title">
              {{ "my-bookeds.train-flight.dep-date" | translate }}
            </div>

            <div class="content">
              <span
                class="labels"
                *ngIf="type?.toLowerCase() !== 'train'"
              >
                {{
                  activeBooking.departLocalDate
                    ? transformDate(activeBooking.departLocalDate)
                    : activeBooking.checkIn
                    ? (activeBooking.checkIn | dateMoment : "YYYY-MM-DD")
                    : activeBooking.departDate
                    ? getDate(activeBooking.departDate)
                    : activeBooking.beginDate
                    ? getDate(activeBooking.beginDate)
                    : ""
                }}
              </span>
              <span
                class="labels"
                *ngIf="type?.toLowerCase() === 'train'"
              >
                {{
                  activeBooking.outwardDate?.departDate
                    ? getDate(activeBooking.outwardDate.departDate)
                    : activeBooking.departDate
                    ? getDate(activeBooking.departDate)
                    : ""
                }}
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'flight' && activeBooking.arrivalDate?.outbound">
            <div class="title">
              {{ "flight.detail-flight.arrival-date-departure" | translate }}
            </div>
            <div class="content">
              <span class="labels">
                {{ activeBooking.arrivalDate.outbound | dateMoment : "YYYY-MM-DDTHH:mm:ss" : "DD/MM/YYYY HH:mm" }}
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'flight' && activeBooking.totalTime?.outbound">
            <div class="title">
              {{ "flight.detail-flight.flight-time-departure" | translate }}
            </div>
            <div class="content">
              <span class="labels">
                {{ activeBooking.totalTime.outbound }}
              </span>
            </div>
          </div>
          <div
            class="title-content-container"
            *ngIf="
              activeBooking.returnDate ||
              activeBooking.endDate ||
              activeBooking.checkOut
            "
          >
            <div class="title">
              {{ "my-bookeds.train-flight.ret-date" | translate }}
            </div>

            <div class="content">
              <span class="labels" *ngIf="type?.toLowerCase() !== 'train'">
                {{
                  activeBooking.returnLocalDate
                    ? transformDate(activeBooking.returnLocalDate)
                    : activeBooking.checkOut
                    ? (activeBooking.checkOut | dateMoment : "YYYY-MM-DD")
                    : activeBooking.returnDate
                    ? getDate(activeBooking.returnDate)
                    : activeBooking.endDate
                    ? getDate(activeBooking.endDate)
                    : ""
                }}
              </span>

              <span class="labels" *ngIf="type?.toLowerCase() === 'train'">
                {{
                  activeBooking.returnDate?.departDate
                    ? getDate(activeBooking.returnDate.departDate)
                    : getDate(activeBooking.returnDate)
                }}
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'flight' && activeBooking.arrivalDate?.return">
            <div class="title">
              {{ "flight.detail-flight.arrival-date-return"| translate }}
            </div>
            <div class="content">
              <span class="labels">
                {{ activeBooking.arrivalDate.return | dateMoment : "YYYY-MM-DDTHH:mm:ss" : "DD/MM/YYYY HH:mm" }}
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'flight' && activeBooking.totalTime?.return">
            <div class="title">
              {{ "flight.detail-flight.flight-time-return" | translate }}
            </div>
            <div class="content">
              <span class="labels">
                {{ activeBooking.totalTime.return }}
              </span>
            </div>
          </div>
        </ng-container>
        <!--FLIGHT TRAIN CAR-->
        <div *ngIf="type === 'flight' || type === 'train' || type === 'car'">
          <div class="title-content-container">
            <div class="title">
              {{ "my-bookeds.train-flight.create-date" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{
                activeBooking.createdAt | dateMoment : "YYYY-MM-DD" : "DD/MM/YYYY"
              }}</span>
            </div>
          </div>
        </div>
        <div class="title-content-container" *ngIf="(type === 'flight' || type === 'train' || type === 'car') && activeBooking.travelTitle">
          <div class="title">{{"excel.related-project" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.travelTitle}}</span>
          </div>
        </div>
        <!-- CAR -->
        <div class="title-content-container" *ngIf=" type === 'car' && activeBooking.provider && isEmployee">
          <div class="title">
            {{ "car.form-car.provider" | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.provider | titlecase }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && activeBooking.order && isEmployee">
          <div class="title">
            {{"company.booked.order-code" | translate}}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.order }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && isEmployee && activeBooking.supplierInvoice">
          <div class="title">
            {{ 'company.bills.supplier-invoice' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.supplierInvoice }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && isEmployee && activeBooking.invoiced">
          <div class="title">
            {{ 'flight.multifamily.baggage' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ ('company.company-booked.invoiced-' + activeBooking.invoiced) | translate }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && isEmployee && activeBooking.bookType">
          <div class="title">
            {{ 'company.company-booked.booking-type' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ (getBookTypeKey(activeBooking.bookType) | translate) || activeBooking.bookType }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.paymentCard && fromTransactions && (type === 'car')">
          <div class="title">{{"company.transaction.filters.payment-card" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.paymentCard.name}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && activeBooking.locator">
          <div class="title">{{"my-bookeds.train-flight.locator" | translate}}</div>
          <div class="content">
            <span>{{activeBooking.locator}}</span>
          </div>
        </div>

        <div class="title-content-container" *ngIf="type === 'car'">
          <div class="title">
            {{ "car.insurance-excess" | translate }}
          </div>
          <div class="content">
            <span class="labels">{{(activeBooking.insuranceWithExcess ? 'common.yes' : 'common.no') | translate }}</span>
          </div>
        </div>

        <div class="title-content-container" *ngIf="type === 'car' && activeBooking.age != null">
          <div class="title">{{ 'car.form-car.age' | translate }}</div>
          <div class="content"><span class="labels">{{ activeBooking.age }}</span></div>
        </div>
        <div class="title-content-container" *ngIf="type === 'car' && activeBooking.agent && isEmployee">
          <div class="title">
            <span>{{ "project.my-projects.agent" | translate }}</span>
          </div>
          <div class="content multiple">
            <span >{{activeBooking.agent | titlecase}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.traveller && type === 'car'">
          <div class="title">
            <span>{{'my-bookeds.flight.travellers' | translate}}</span>
          </div>
          <div class="content multiple">
            <span>{{ activeBooking.traveller?.name | titlecase }} {{ activeBooking.traveller?.surname | titlecase }}</span>
          </div>
        </div>
        <!-- FLIGHT TRAIN -->
        <div *ngIf="type === 'flight' || type === 'train'">
          <div class="title-content-container" *ngIf="type === 'train' && activeBooking.extraInfo?.[0]?.extras?.length">
            <div class="title">{{ 'flight.form-flight.extras' | translate }}</div>
            <div class="content multiple">
              <span *ngFor="let extra of activeBooking.extraInfo[0].extras">
                {{ extra.description }}
                <span *ngIf="extra.type === 'outbound' || extra.type === 'outward'"> · {{ 'my-bookeds.train.way-going' | translate }}</span>
                <span *ngIf="extra.type === 'return'"> · {{ 'my-bookeds.train.come-back' | translate }}</span>
                <span *ngIf="extra.price != null && extra.price !== ''"> · {{ extra.price | price }}</span>
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.author">
            <div class="title">
              {{ "my-bookeds.view.bookedMadePerson" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.author }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.provider">
            <div class="title">
              {{ 'my-bookeds.view.provider' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.provider | titlecase }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking?.outwardReferences">
            <div class="title">
              {{ 'train.outward-references' | translate }}
            </div>
            <div class="content">
              <span *ngFor="let ref of activeBooking?.outwardReferences" class="labels">{{ ref | titlecase }}, </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking?.returnReferences">
            <div class="title">
              {{ 'train.return-references' | translate }}
            </div>
            <div class="content">
              <span *ngFor="let ref of activeBooking?.returnReferences" class="labels">{{ ref | titlecase }}, </span>
            </div>
          </div>
          <div class="title-content-container">
            <div class="title">
              {{
                (type === "flight"
                  ? "my-bookeds.train-flight.pnr"
                  : "my-bookeds.train-flight.locator"
                ) | translate
              }}
            </div>
            <div class="content">
              <span class="labels">{{
                activeBooking.locator ??
                  activeBooking.pnr ??
                  ("flight.result-flight.select-seat.unknown-terminal"
                    | translate)
              }}</span>
            </div>
          </div>
          <div *ngIf="type === 'flight' && activeBooking.airlineLocator" class="title-content-container">
            <div class="title">
              {{"my-bookeds.train-flight.airline-locator" | translate}}
            </div>
            <div class="content">
              <span class="labels" style="padding-left: 1rem;">{{activeBooking.airlineLocator}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.supplierInvoice">
            <div class="title">
              {{ 'company.bills.supplier-invoice' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.supplierInvoice }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.invoiced">
            <div class="title">
              {{ 'flight.multifamily.baggage' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ ('company.company-booked.invoiced-' + activeBooking.invoiced) | translate }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.bookType">
            <div class="title">
              {{ 'company.company-booked.booking-type' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ (getBookTypeKey(activeBooking.bookType) | translate) || activeBooking.bookType }}</span>
            </div>
          </div>
          <div *ngIf="type === 'flight' && activeBooking.annotationsExtras" class="title-content-container">
            <div class="title">
              {{"flight.form-flight.extras" | translate}}
            </div>
            <div class="content">
              <span class="labels" style="padding-left: 1rem;">{{activeBooking.annotationsExtras}}</span>
            </div>
          </div>
          <div *ngIf="(type === 'flight' || type === 'train') && activeBooking.class" class="title-content-container">
            <div class="title">
              {{"common.class-flight" | translate}}
            </div>
            <div class="content">
              <span class="labels" style="padding-left: 1rem;">{{activeBooking.class}}</span>
            </div>
          </div>
          <div *ngIf="(type === 'flight' || type === 'train') && activeBooking.observations" class="title-content-container">
            <div class="title">
              {{"flight.form-flight.extras" | translate}}
            </div>
            <div class="content">
              <span class="labels" style="padding-left: 1rem;">{{activeBooking.observations}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.order && isEmployee">
            <div class="title">
              {{"company.booked.order-code" | translate}}
            </div>
            <div class="content">
              <span class="labels">{{activeBooking.order}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.paymentCard && fromTransactions">
            <div class="title">{{"company.transaction.filters.payment-card" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.paymentCard.name}}</span>
            </div>
          </div>
          <div
            class="title-content-container"
            *ngIf="activeBookingGroupedAncillaries.length > 0"
          >
            <div class="title">
              <span>{{ 'my-bookeds.flight.baggage' | translate }}</span>
            </div>

            <div class="content multiple">
              <div *ngFor="let group of activeBookingGroupedAncillaries" class="mb-2">
                <div *ngIf="group.route" style="font-weight: 600;">
                  {{ group.route }}
                </div>

                <div *ngFor="let baggage of group.items" style="margin-left: 0.5rem;">
                  <span>{{ baggage.shortName }}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="title-content-container" *ngIf="(type === ('flight') && activeBooking.extraInfo && activeBooking.extraInfo.length > 0 && activeBooking.extraInfo[0].fare && activeBooking.extraInfo[0].fare.fareName) || (type === ('train') && activeBooking.extraInfo && activeBooking.extraInfo.length > 0 && activeBooking.extraInfo[0].fare && activeBooking.extraInfo[0].fare.length > 0)">
            <div class="title">
              <span>{{'my-bookeds.train.tax' | translate}}</span>
            </div>
            <div class="content" *ngIf="type === 'flight' ">
              <span>{{activeBooking.extraInfo[0].fare.fareName}}</span>
            </div>

            <!-- TRAIN -->
            <div class="content multiple" *ngIf="type === ('train') && activeBooking.extraInfo.length > 0">
              <div *ngFor="let fare of activeBooking.extraInfo[0].fare; let i = index" class="one-way-and-return">
                <span class="subtitle" *ngIf="i === 0">{{'my-bookeds.train.way-going' | translate}}</span>
                <span class="subtitle" *ngIf="i === 1">{{'my-bookeds.train.come-back' | translate}}</span>
                <span class="text">{{fare.fareName}}</span>
              </div>
            </div>
          </div>
          <div class="title-content-container" *ngIf="(type === 'flight' || type === 'train') && activeBooking.extraInfo[0]?.seats?.length > 0 && activeBooking.extraInfo[0].seats[0]?.seat">
            <div class="title">
              <span>{{ 'my-bookeds.train-flight.seat' | translate }}</span>
            </div>
            <div class="content multiple">
              <div class="seat-info" *ngFor="let seat of activeBooking.extraInfo[0].seats" style="margin-bottom: 0.25rem;">
                <span class="labels"><strong>{{ seat.seat }}</strong></span>
                <span *ngIf="seat.segment" class="labels" style="margin-left: 0.5rem;">
                  {{
                    ((seat.segment || '').toLowerCase() === 'outbound') ? ('train.confirm-stepper-container.seat-selection.return' | translate) :
                    ((seat.segment || '').toLowerCase() === 'return')   ? ('train.confirm-stepper-container.seat-selection.return'   | translate) :
                    seat.segment
                  }}
                </span>
                <span *ngIf="seat.departure && seat.arrival" class="labels" style="margin-left: 0.5rem;">({{ seat.departure }} → {{ seat.arrival }})</span>
              </div>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'flight' && activeBooking.scales?.length > 0 && hasValidScales(activeBooking)">
            <div class="scales-container">
              <ng-container *ngFor="let scale of activeBooking.scales">
                <div class="scale-row" *ngIf="scale.layovers?.length > 0">
                  <div class="scale-label">
                    {{
                      scale.type === 'outbound'
                        ? ('flight.detail-flight.scales-way-going' | translate)
                        : ('flight.detail-flight.scales-come-back' | translate)
                    }}
                  </div>
                  <div class="scale-details">
                    <div *ngFor="let layover of scale.layovers" class="layover">
                      <div class="route">{{ layover.from }} → {{ layover.to }}</div>
                      <div>{{ layover.company }} {{ layover.flightNumber }}</div>
                      <div *ngIf="layover.arrivalTime">{{ 'booking-details.layover-arrival' | translate }}: {{ formatTransportTime(layover.arrivalTime) }}</div>
                      <div *ngIf="layover.departureTime">{{ 'booking-details.layover-departure' | translate }}: {{ formatTransportTime(layover.departureTime) }}</div>
                      <div class="duration">{{ 'booking-details.duration' | translate }}: {{ layover.duration }}</div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="title-content-container" *ngIf="type === 'train' || (activeBooking.extraInfo && activeBooking.extraInfo.length > 0)">
            <div class="title">
              <span>{{ 'my-bookeds.flight.travellers' | translate }}</span>
            </div>
            <div class="content multiple">
              <div *ngIf="type === 'train' || (activeBooking.extraInfo && activeBooking.extraInfo.length > 0)">
                <span *ngIf="type === 'flight' && activeBooking.extraInfo[0].passengerName">{{activeBooking.extraInfo[0].passengerName}}</span>
                <span *ngIf="type === 'flight' && activeBooking.extraInfo[0].ffCard">{{activeBooking.extraInfo[0].ffCard}}</span>
            
                <span *ngIf="type === 'train'">{{ activeBooking.extraInfo?.[0]?.passengerFullName || getTravellerDisplayName(activeBooking, activeBooking) }}</span>
              </div>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.agent && (type === 'train' || type === 'flight') && isEmployee">
            <div class="title">
              <span>{{ "project.my-projects.agent" | translate }}</span>
            </div>
            <div class="content multiple">
              <span >{{activeBooking.agent | titlecase}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="hasValidAirlines()">
            <div class="title">
              <span>{{ 'csv.flight.airline' | translate }}</span>
            </div>
            <div class="content multiple">
              <div class="airline" *ngFor="let airline of activeBooking.airlines; let i = index">
                <ng-container *ngIf="airline?.trim()">
                  <span *ngIf="i === 0">{{ 'my-bookeds.train.way-going' | translate }}</span>
                  <span *ngIf="i === 1">{{ 'my-bookeds.train.come-back' | translate }}</span>

                  <img
                    [src]="getLogo(airline)"
                    alt="airline-logo"
                    (error)="onImageError($event)"
                    [attr.data-airline]="airline"
                  />
                  <span class="airline-name" *ngIf="hiddenAirlines.has(airline)">
                    {{ airline }}
                  </span>
                </ng-container>
              </div>
            </div>
          </div>
          <div class="title-content-container" *ngIf="hasValidCarriers()">
            <div class="title">
              <span>{{ 'train.form-train.carrier' | translate }}</span>
            </div>
            <div class="content multiple">
              <div class="carrier" *ngFor="let carrier of activeBooking.carriers; let i = index">
                <ng-container *ngIf="carrier?.trim()">
                  <span *ngIf="i === 0">{{ 'my-bookeds.train.way-going' | translate }}</span>
                  <span *ngIf="i === 1">{{ 'my-bookeds.train.come-back' | translate }}</span>
                  <span class="carrier-name">{{ carrier }}</span>
                </ng-container>
              </div>
            </div>
        </div>
          <div class="title-content-container" *ngIf=" type === 'train' && activeBooking.extraInfo && activeBooking.extraInfo.length > 0 && activeBooking.extraInfo[0].seats && activeBooking.extraInfo[0].seats.length > 0 &&  activeBooking.extraInfo[0].seats[0].outwardSeats && activeBooking.extraInfo[0].seats[0].outwardSeats.length > 0 ">
            <div class="title">
              <span>{{'my-bookeds.train-flight.seat' | translate}}</span>
            </div>
            <div class="content multiple">
              <div class="seats" *ngFor="let seat of activeBooking.extraInfo[0].seats[0].outwardSeats && activeBooking.extraInfo[0].seats; let i = index">
                <div *ngIf="seat.outwardSeats.length > 0">
                  <span *ngIf="seat.outwardSeats.length > 0">{{'my-bookeds.train.way-going' | translate}}</span>
                  <span style="font-weight: 300;" *ngFor="let outwardSeats of seat.outwardSeats" >{{outwardSeats.seat_code}}</span>
                </div>
                <div *ngIf="seat.returnSeats.length > 0">
                  <span *ngIf="seat.returnSeats.length > 0">{{'my-bookeds.train.come-back' | translate}}</span>
                  <span style="font-weight: 300;" *ngFor="let returnSeats of seat.returnSeats" >{{returnSeats.seat_code}}</span>
                </div>
              </div>
            </div>
          </div>
          <div
            class="title-content-container"
            *ngIf="hasDiscountCardOrFlight() != -1"
          >
            <div class="title">
              {{
                (type === "flight"
                  ? "my-bookeds.train-flight.ff-card"
                  : "my-bookeds.train-flight.renfe-card"
                ) | translate
              }}
            </div>
            <div class="content">
              <span class="labels">{{
                hasDiscountCardOrFlight() === 1
                  ? activeBooking.extraInfo[0].discountCard
                  : activeBooking.extraInfo[0].ffCard
              }}</span>
            </div>
          </div>
        </div>
        <!--AUTOMATIZED HOTEL-->
        <ng-container *ngIf="type === 'bookingApiReference' || type === 'custom-booking'">
          <div class="title-content-container">
            <div class="title">
              {{ "my-bookeds.view.bookedMadePerson" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.author }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="rooms">
            <div class="title">
              {{ "my-bookeds.view.totalRooms" | translate }}
            </div>
            <div class="content">
              {{ type === 'custom-booking' ? 1 : (rooms?.length ?? activeBooking.rooms) }}
            </div>
          </div>
          <div class="title-content-container" *ngIf="totalAdults || activeBooking.people">
            <div class="title">
              {{ "my-bookeds.view.totalAdults" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ totalAdults > 0 ? totalAdults : activeBooking.people }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="totalChildren">
            <div class="title">
              {{ "my-bookeds.view.totalChildrens" | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ totalChildren }}</span>
            </div>
          </div>
          <div
            class="title-content-container"
            *ngIf="activeBookingTravellers.length > 0"
          >
            <div class="title">
              <span>{{ 'my-bookeds.flight.travellers' | translate }}</span>
            </div>

            <div
              *ngIf="type === 'bookingApiReference' || type === 'custom-booking'"
              class="content multiple"
            >
              <span *ngFor="let traveller of activeBookingTravellers">
                {{ traveller?.name | titlecase }} {{ traveller?.lastname | titlecase }}
              </span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.agent && isEmployee">
            <div class="title">
              <span>{{ "project.my-projects.agent" | translate }}</span>
            </div>
            <div class="content">
              <span>{{activeBooking.agent | titlecase}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.apiReference && type === 'bookingApiReference'">
            <div class="title">{{"my-bookeds.train-flight.locator" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.apiReference}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.supplierInvoice">
            <div class="title">
              {{ 'company.bills.supplier-invoice' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ activeBooking.supplierInvoice }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.invoiced">
            <div class="title">
              {{ 'flight.multifamily.baggage' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ ('company.company-booked.invoiced-' + activeBooking.invoiced) | translate }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="isEmployee && activeBooking.bookType">
            <div class="title">
              {{ 'company.company-booked.booking-type' | translate }}
            </div>
            <div class="content">
              <span class="labels">{{ (getBookTypeKey(activeBooking.bookType) | translate) || activeBooking.bookType }}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.locator && type === 'custom-booking'">
            <div class="title">{{"my-bookeds.train-flight.locator" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.locator}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="(type === 'custom-booking' || type.toLowerCase() === 'bookingapireference') && activeBooking.travelTitle">
            <div class="title">{{"excel.related-project" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.travelTitle}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.order && isEmployee && (type === 'bookingApiReference' || 'custom-booking')">
            <div class="title">{{"company.booked.order-code" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.order}}</span>
            </div>
          </div>
          <div class="title-content-container" *ngIf="activeBooking.paymentCard && fromTransactions && (type === 'bookingApiReference' || 'custom-booking')">
            <div class="title">{{"company.transaction.filters.payment-card" | translate}}</div>
            <div class="content">
              <span>{{activeBooking.paymentCard.name}}</span>
            </div>
          </div>
        </ng-container>
      </div>
      <div class="row mt-3" *ngIf="type === 'bookingApiReference' || type === 'custom-booking'">
        <div class="col-12 hotel-details">
          <h5 class="heading-6">{{ "my-bookeds.view.hotel-details" | translate }}</h5>
        </div>
      </div>
      <div *ngIf="activeBooking && (type === 'bookingApiReference' || type === 'custom-booking')">
        <div class="title-content-container" style="gap: 1rem;">
          <div class="title">{{ "common.name" | translate }}</div>
          <div class="content hotel-name">
            <a 
              *ngIf="activeBooking.type?.toLowerCase() === 'airbnb' && isValidUrl(activeBooking.hotel?.name ?? activeBooking.hotelName)" 
              [href]="activeBooking.hotel?.name ?? activeBooking.hotelName" 
              target="_blank" 
              rel="noopener noreferrer"
              class="labels airbnb-link"
            >
              {{ activeBooking.hotel?.name ?? activeBooking.hotelName }}
            </a>
            <span 
              *ngIf="activeBooking.type?.toLowerCase() !== 'airbnb' || !isValidUrl(activeBooking.hotel?.name ?? activeBooking.hotelName)"
              class="labels"
            >
              {{ activeBooking.hotel?.name ?? activeBooking.hotelName }}
            </span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="isEmployee && activeBooking.provider">
          <div class="title">
            {{ 'my-bookeds.view.provider' | translate }}
          </div>
          <div class="content">
            <span class="labels">{{ activeBooking.provider | titlecase }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="rooms && rooms.length > 0">
          <div class="title">{{ "my-bookeds.view.room" | translate }}</div>
          <div class="content">
            <div *ngFor="let r of rooms">
              <span class="labels">{{ r.name }} </span>
            </div>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.stars">
          <div class="title">{{ "common.stars" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.hotel?.stars }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.email">
          <div class="title">{{ "common.email" | translate }}</div>
          <div class="content">
            <span class="labels string-long">{{ activeBooking.hotel?.email }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.phone">
          <div class="title">{{ "common.phone" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.hotel?.phone }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.address || activeBooking.destinationName">
          <div class="title">{{ "common.address" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.hotel?.address ?? activeBooking.destinationName }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.roomType && type === 'custom-booking'">
          <div class="title">{{ "my-bookeds.view.room-type" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.roomType }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.boardType && type === 'custom-booking'">
          <div class="title">{{ "my-bookeds.view.rules" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.boardType }}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.destinationName">
          <div class="title">{{ "common.city" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.hotel?.destinationName}}</span>
          </div>
        </div>
        <div class="title-content-container" *ngIf="activeBooking.hotel?.postalCode">
          <div class="title">{{ "common.postal-code" | translate }}</div>
          <div class="content">
            <span class="labels">{{ activeBooking.hotel?.postalCode }}</span>
          </div>
        </div>

        <div class="title-content-container" *ngIf="rooms && rooms.length > 0">
          <div class="title">{{ "my-bookeds.view.room-type" | translate }}</div>
          <div class="content">
            <div *ngFor="let r of rooms">
              <span class="labels">{{
                rooms[0]?.rates[0]?.boardName
              }}</span>
            </div>
          </div>
        </div>

        <div
          class="title-content-container"
          *ngIf="type === 'bookingApiReference'"
        >
          <div class="title">
            {{ "search.search-booked.free-cancel" | translate }}
          </div>
          <div class="content">
            <span class="labels">
              {{
                hasFreeCancellationHotel(activeBooking)
                  ? ("common.yes" | translate)
                  : ("common.no" | translate)
              }}
            </span>
          </div>
        </div>

        <div
          class="title-content-container cancellation-row"
          *ngIf="hotelCancellationDetails.length > 0 && type === 'bookingApiReference'"
        >
          <div class="title">
            {{ "my-bookeds.view.cancellation-detail" | translate }}
          </div>

          <div class="content cancellation-details">
            <div *ngFor="let policy of hotelCancellationDetails" class="policy-item">
              <span class="labels">{{ policy }}</span>
            </div>
          </div>
        </div>

        <div class="title-content-container" *ngIf="rooms[0]?.rates[0]?.rateComments">
          <div class="title">{{ "my-bookeds.view.comments" | translate }}</div>
          <div class="content" id="contentHotelComments">
            <span class="labels">{{
              rooms[0]?.rates[0]?.rateComments
            }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
